import PageHeader from "@/components/PageHeader";
import Faq from "@/components/Faq";
import CtaBand from "@/components/CtaBand";
import { useSeo } from "@/lib/seo";

export default function VisitPage() {
  useSeo({
    title: "FAQ — Cool Runnings Cape Town | Toboggan Family Park",
    description:
      "Answers to everything families ask: ride prices, online tickets, opening hours, rain policy, birthdays and more — Cool Runnings Cape Town.",
    keywords:
      "Cool Runnings FAQ, toboggan park questions, Cool Runnings ticket prices FAQ, when is Cool Runnings open, toboggan age rules Cape Town",
    image: "/og/visit.jpg",
  });
  return (
    <>
      <PageHeader
        pageName="FAQ"
        eyebrow="Good to know"
        title="FAQs"
        goodgirlTitle
        image="/park-bar.jpg"
      />

      <Faq />
      <CtaBand />
    </>
  );
}
